import { Api } from "../../Api";

export const getBarChartDetails = async (
  collectionId: string | undefined
) => {
  let url = `/collection/graph-data/${collectionId}`;
  const response = await Api.get(url);
  return response;
};

export const getLabelDetails = async () => {
  let url = `/collection/graph-labels`;
  const response = await Api.get(url);
  return response;
};